import React from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
   IconButton,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import EditTaskModal from '../../components/Modal/EditTaskModal'

export default function LegacyTasksModal({ open, onClose, tasks = [] }) {
  const [selectedTask, setSelectedTask] = React.useState(null)

  return (
    <>
      <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      >


        <DialogTitle sx={{pb:1}}>
          <Box display="flex" justifyContent="space-between" alignItems="center">

            <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>

              <Box sx={{
                width: 45,
                height: 45,
                borderRadius: '100%',
                backgroundColor: '#deecff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_1496_8684)">
                    <path d="M8 6V4H4V22H11M8 6H16M8 6V2H16V6M16 6V4H20V11M19 15V19M19 19V23M19 19H15M19 19H23" stroke="#2666BE" stroke-width="2" stroke-linecap="square" />
                      </g>
                          <defs>
                              <clipPath id="clip0_1496_8684">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                          </defs>
                </svg>
                </Box>
              <Typography sx={{
                color: '#3a3a3a',
                fontWeight: 600,
                fontSize: '20px',
              }}
              >
                  Legacy Tasks Missing Working Period
              </Typography>
                
            </Box>

            <Box>
                <IconButton
                  onClick={onClose}
                  sx={{ color: '#3a3a3a', ml: 1 }}
                >
                  <CloseIcon />
                </IconButton>
            </Box>   
          </Box>   
        </DialogTitle>

        <DialogContent sx={{ pt: 1 }}>
          <Typography variant="body2" sx={{ color: '#667085', mb: 2 }}>
            These tasks are excluded from the Gantt chart until a working period is added.
          </Typography>
          

          <List disablePadding>
            {tasks.map((task, index) => (
              <React.Fragment key={task?.id || index}>
                <ListItem
                  disableGutters
                  secondaryAction={
                    <Button size="small" variant="outlined" sx={{ textTransform: 'none' }} onClick={() => setSelectedTask(task)}>
                      Set Working Period
                    </Button>
                  }
                >
                  <ListItemText
                    primary={task?.name || 'Untitled task'}
                    secondary={
                      <Stack spacing={0.25} sx={{ mt: 0.5 }}>
                        <Typography component="span" variant="caption" sx={{ color: '#667085' }}>
                          Project: {task?.project?.name || task?.project_name || '-'}
                        </Typography>
                        <Typography component="span" variant="caption" sx={{ color: '#667085' }}>
                          Due Date: {task?.due_date || '-'}
                        </Typography>
                      </Stack>
                    }
                  />
                </ListItem>
                {index < tasks.length - 1 ? <Divider /> : null}
              </React.Fragment>
            ))}

            {!tasks.length ? (
              <Box sx={{ py: 2 }}>
                <Typography variant="body2" sx={{ color: '#667085' }}>
                  No legacy tasks found.
                </Typography>
              </Box>
            ) : null}
          </List>
        </DialogContent>
      </Dialog>

      <EditTaskModal
        open={!!selectedTask}
        onClose={() => setSelectedTask(null)}
        taskData={selectedTask}
        onSave={() => {
          setSelectedTask(null)
          onClose?.()
        }}
      />
    </>
  )
}
